import React from 'react'
import Button from '../atoms/Button'
import Text from '../atoms/TextNew'
import View from '../atoms/View'
import Space from '../atoms/Space'
import CloseXSvg from '../other/svg/CloseXSvg'
import { Brand } from 'src/redux/brandsReducer'

interface Motorbike {
  id: string
  model: string
  brand_id: number
}

interface DeleteMotorbikeModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  motorbike: Motorbike | null
  brands: Brand[]
}

const DeleteMotorbikeModal = ({
  isOpen,
  onClose,
  onConfirm,
  motorbike,
  brands
}: DeleteMotorbikeModalProps): JSX.Element => {
  if (!isOpen || motorbike === null) return <></>

  const brand = brands.find((b) => b.id === motorbike.brand_id)

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="rounded-4 p-8 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto bg-groupBlue">
        <View className="flex justify-between items-center mb-6">
          <Text className="text-xl font-Bold text-white">Delete Motorbike</Text>
          <Button onClick={onClose} customStyles="text-white !bg-groupBlue">
            <CloseXSvg className="w-6 h-6" />
          </Button>
        </View>

        <Text className="text-l font-Medium text-white mb-6">Are you sure you want to delete this motorbike?</Text>

        <div className="bg-white bg-opacity-10 p-4 rounded-2 mb-6">
          <Text className="text-l font-Medium text-white mb-2">Model: {motorbike.model}</Text>
          <Text className="text-l font-Medium text-white">Brand: {brand?.name ?? 'Unknown Brand'}</Text>
        </div>

        <Space y={6} />

        <View className="flex justify-end gap-4">
          <Button
            onClick={onClose}
            customStyles="px-6 py-3 border border-grey text-darkGrey hover:bg-lightGrey transition-colors rounded-2">
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            customStyles="px-6 py-3 bg-errorRed text-white hover:bg-red-700 transition-colors rounded-2">
            Delete
          </Button>
        </View>
      </div>
    </div>
  )
}

export default DeleteMotorbikeModal
